import { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import Api from "../../utils/api";

export const CuotasYPagoFinMercadoPago = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const [isLoaging, setIsLoading] = useState(true);
  const [message, setMessage] = useState("Cargando...");

  useEffect(() => {
    /**
     * obtener el result
     */

    const query: { [index: string]: string } = {};

    const searchParams = new URLSearchParams(search);
    const params = Array.from(searchParams.keys());
    for (const key of params) {
      query[key] = searchParams.get(key) ?? "";
    }

    const queryString = btoa(JSON.stringify(query));

    Api("finMercadoPago", undefined, "result=" + queryString)
      .post()
      .then((res) => {
        setMessage(res.mensaje);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [search]);

  return (
    <div>
      <Modal
        onLoadAceptar={isLoaging}
        hideClose={true}
        btnAceptar="Aceptar"
        onAceptar={() => navigate("/")}
        title="Detalle del Pago"
        onClose={() => {}}
        show={true}
      >
        <p dangerouslySetInnerHTML={{ __html: message }}></p>
      </Modal>
    </div>
  );
};
